var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTypeCheckFatSizelWeightfilled = function SvgTypeCheckFatSizelWeightfilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343330",
    d: "m30.414 11.364-16.05 16.05a2 2 0 0 1-2.828 0l-8.952-9a2 2 0 0 1 0-2.827l2.5-2.5a2 2 0 0 1 2.822 0L13 18.028 25.095 6.082a2 2 0 0 1 2.824 0l2.494 2.443a2 2 0 0 1 0 2.84"
  })));
};
export default SvgTypeCheckFatSizelWeightfilled;